// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"511":"bacb3824","549":"3aa8e7c1"}[chunkId] + ".chunk.js";
};